import { Link } from "react-router-dom";
import { COMPANY } from "../../lib/api";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] border-t border-[#27272A] pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={COMPANY.logo}
                alt="Technological Horizons"
                className="h-12 w-auto"
              />
              <div>
                <div className="font-heading text-lg text-white font-semibold">
                  Technological Horizons
                </div>
                <div className="font-mono-th text-[10px] uppercase tracking-[0.25em] text-[#A1A1AA]">
                  Fiber Optic · Specialists
                </div>
              </div>
            </div>
            <p className="text-sm text-[#A1A1AA] leading-relaxed max-w-md">
              Κατασκευή και άμεση αποκατάσταση βλαβών οπτικών ινών, εντός και
              εκτός χώρου του πελάτη. Συνεργάτες των μεγαλύτερων παρόχων
              τηλεπικοινωνιών στην Ελλάδα.
            </p>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="overline mb-5">Πλοήγηση</div>
            <ul className="space-y-3 text-sm">
              {[
                { l: "Αρχική", to: "/" },
                { l: "Υπηρεσίες", to: "/services" },
                { l: "Εταιρεία", to: "/about" },
                { l: "Καριέρα", to: "/careers" },
                { l: "Επικοινωνία", to: "/contact" },
              ].map((i) => (
                <li key={i.to}>
                  <Link
                    to={i.to}
                    className="text-[#A1A1AA] hover:text-[#E63946] transition-colors"
                  >
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <div className="overline mb-5">Στοιχεία Επικοινωνίας</div>
            <ul className="space-y-3 text-sm">
              <li className="text-[#A1A1AA]">
                <span className="text-white">{COMPANY.address}</span>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.phone}`}
                  className="text-[#A1A1AA] hover:text-[#E63946] transition-colors"
                >
                  Τηλ. {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.mobile}`}
                  className="text-[#A1A1AA] hover:text-[#E63946] transition-colors"
                >
                  Κιν. {COMPANY.mobile}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="text-[#E63946] hover:underline"
                >
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="section-divider mt-12" />

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-mono-th text-[#A1A1AA]">
            © {year} Technological Horizons. Με την επιφύλαξη παντός δικαιώματος.
          </p>
          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="text-xs font-mono-th text-[#A1A1AA] hover:text-[#E63946] transition-colors uppercase tracking-[0.2em]"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
